import PropTypes from 'prop-types';
import { Link, useLocation, matchPath } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| NAVIGATION - LIST ITEM (light ERP sidebar) ||============================== //

export default function NavItem({ item, level }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { pathname } = useLocation();
  const isSelected = !!matchPath({ path: item?.link ? item.link : item.url, end: false }, pathname);

  const Icon = item.icon;
  const nested = level > 1;

  const button = (
    <ListItemButton
      component={Link}
      to={item.url}
      selected={isSelected}
      disabled={item.disabled}
      onClick={() => downLG && handlerDrawerOpen(false)}
      sx={(theme) => ({
        minHeight: 34,
        py: 0.5,
        my: '1px',
        borderRadius: '6px',
        color: theme.vars.palette.grey[700],
        transition: 'background-color .12s, color .12s',
        ...(drawerOpen
          ? { mx: 1, pl: nested ? 4.5 : 1.25, pr: 1 }
          : { mx: 'auto', width: 40, height: 40, justifyContent: 'center', px: 0 }),
        '&:hover': { backgroundColor: theme.vars.palette.grey[100] },
        '&.Mui-selected': {
          backgroundColor: theme.vars.palette.primary.lighter,
          color: theme.vars.palette.primary.dark,
          '&:hover': { backgroundColor: theme.vars.palette.primary.lighter },
          '& .MuiListItemIcon-root': { color: theme.vars.palette.primary.main },
          '& .MuiListItemText-primary': { fontWeight: 600 }
        }
      })}
    >
      {Icon && !nested && (
        <ListItemIcon sx={{ minWidth: drawerOpen ? 26 : 0, color: 'grey.500', justifyContent: 'center' }}>
          <Icon size={17} strokeWidth={1.6} />
        </ListItemIcon>
      )}
      {drawerOpen && <ListItemText primary={item.title} primaryTypographyProps={{ fontSize: 13, fontWeight: 500, noWrap: true }} />}
    </ListItemButton>
  );

  return drawerOpen ? (
    button
  ) : (
    <Tooltip title={item.title} placement="right" arrow>
      {button}
    </Tooltip>
  );
}

NavItem.propTypes = { item: PropTypes.any, level: PropTypes.number };
